import styled from "styled-components";

export const PasswordChangeSuccessfullStyled = styled.div`
  margin: auto;
  border-radius: 12px;
  width: 428px;
  height: 386px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  border-radius: 12px;
  .password_change_successfull_title {
    margin-bottom: 15px;
    padding-top: 160px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .password_change_successfull_subtitle {
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
`;
